import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '../UI';
import Landing from './index';

export default function Strapline() {
	return (
		<Landing>
			<Typography variant="h2" style={{ marginBottom: '1rem' }}>
				<strong>aXcess is a strapline...</strong>
			</Typography>
			<Typography variant="body1">
				Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatum corrupti cupiditate fugit eveniet,
				possimus ipsum quibusdam earum repellat natus dolorum enim quasi commodi doloribus sed sunt eius
				distinctio, ratione mollitia.
			</Typography>
			<Box mt={3} display="flex" alignItems="center" justifyContent="center">
				<Button
					variant="contained"
					color="primary"
					style={{ width: '100%' }}
					component={Link}
					to="/login"
				>
					Demo
				</Button>
			</Box>
		</Landing>
	);
}
